import React, { createContext, useContext } from 'react';

const BrandConfigContext = createContext(null);

/**
 * Injecte une brand config dans tout l'arbre de composants.
 * Génère aussi les classes CSS .font-heading et .font-body depuis la config.
 *
 * Usage :
 *   <BrandConfigProvider config={HOLY_CONFIG}>
 *     <BrandDemoPage config={HOLY_CONFIG} />
 *   </BrandConfigProvider>
 */
export const BrandConfigProvider = ({ config, children }) => {
    const { fonts } = config.brand;

    const fontStyles = `
        @import url('${fonts.googleFontsUrl}');
        .font-heading { font-family: '${fonts.heading}', sans-serif; }
        .font-body    { font-family: '${fonts.body}', sans-serif; }
    `;

    return (
        <BrandConfigContext.Provider value={config}>
            <style dangerouslySetInnerHTML={{ __html: fontStyles }} />
            {children}
        </BrandConfigContext.Provider>
    );
};

/**
 * Hook pour lire la brand config depuis n'importe quel composant enfant.
 *
 * const { brand, welcome, segmentation, result } = useBrandConfig();
 */
export const useBrandConfig = () => {
    const ctx = useContext(BrandConfigContext);
    if (!ctx) throw new Error('useBrandConfig doit être utilisé dans un <BrandConfigProvider>');
    return ctx;
};
